import {AES, HmacMD5} from '@/app-core/lib/crypto/crypto'
import AuthRestApi from '@/app-core/mixins/auth/authRestApi'
import PermissionEnum from '@/app-core/api/enums/PermissionEnum'
import ApiResponseEnum from '@/app-core/api/enums/ApiResponseEnum'
import CustomerModel from '@/app-core/api/models/customer/CustomerModel'
import AuthSocialApi from '@/app-core/mixins/auth/authSocialApi'

export default {
  name: 'Auth',
  data() {
    return {
      authError        : false,
      isAuthLoading    : false,
      isMaintenanceMode: false
    }
  },
  mixins: [AuthRestApi, AuthSocialApi],
  enums : {
    PermissionEnum,
    ApiResponseEnum
  },
  watch: {
    userIsAuthenticated() {
      this.checkIfUserIsAuthenticated()
    }
  },
  created() {
    this.checkIfUserIsAuthenticated()
  },
  methods: {
    checkIfUserIsAuthenticated() {
      if (!this.userIsAuthenticated && this.$route?.meta?.requiresAuth && this.$route?.name !== 'Home') this.$router.replace({name: 'Home'})
    }
  },
  computed: {
    $storage() {
      return this.$localStorage // this.$sessionStorage
    },

    userKey() {
      return HmacMD5.hash('user')
    },

    authorizationTokenKey() {
      return HmacMD5.hash('authorizationToken')
    },

    authorizationToken: {
      get() {
        return AES.decrypt(this.$storage.get(this.authorizationTokenKey))
      },
      set(val) {
        this.$storage.set(this.authorizationTokenKey, AES.encrypt(val))
      }
    },

    user: {
      get() {
        const user = this.$storage.get(this.userKey)
        if (this.$dataStore.User) {
          return new CustomerModel(AES.decrypt(this.$dataStore.User))
        } else if (user) {
          this.$dataStore.User = user
          return new CustomerModel(AES.decrypt(user))
        }
        return null
      },
      set(val) {
        this.$dataStore.User = AES.encrypt(val)
        this.$storage.set(this.userKey, this.$dataStore.User)

        if (val === null || !val) {
          this.$dataStore.User = null
          this.$storage.remove(this.userKey)
          this.$storage.remove(this.authorizationTokenKey)
        }
      }
    },

    userAddresses() {
      return this.user?.Addresses || []
    },

    userHasAddresses() {
      return this.userAddresses.length > 0
    },

    userDefaultAddress() {
      if (!this.userHasAddresses) return null

      return this.userAddresses.length === 1 ? this.userAddresses[0] : this.userAddresses.find(address => address.IsDefault) || this.userAddresses[0]
    },

    userIsAuthenticated() {
      return !!this.user
    },

    userInitials() {
      if (!this.user) return ''

      return (this.user?.Info?.Firstname?.slice(0, 1)?.toLocaleUpperCase(this.$i18n.locale) || '') + (this.user?.Info?.Lastname?.slice(0, 1)?.toLocaleUpperCase(this.$i18n.locale) || '')
    }
  }

}
